// inline=true  → small spinner (1.25rem) for buttons, icons, cells.
// block=true   → medium spinner (2rem) centered inside a card or section.
// default      → fixed full-page overlay for initial page/component loads.
interface Props {
  message?: string;
  inline?: boolean;
  block?: boolean;
}

const LoadingSpinner = ({ message, inline, block }: Props) => {
  if (inline) {
    return <span className="loader loader--sm" role="progressbar" />;
  }

  if (block) {
    return (
      <div className="spinner-wrapper spinner-wrapper--block" role="progressbar">
        <div className="loader loader--md" />
        {message && <span className="spinner-wrapper__message">{message}</span>}
      </div>
    );
  }

  return (
    <div className="spinner-wrapper" role="progressbar">
      <div className="spinner-wrapper__inner">
        <div className="loader" />
        {message && <span className="spinner-wrapper__message">{message}</span>}
      </div>
    </div>
  );
};
export default LoadingSpinner;
